import {
  type ComponentProps, forwardRef,
} from 'react';
import { CheckboxComponent } from '~/_shared/baseComponents/checkbox';
import { checkboxCellStyles } from '~/_shared/baseComponents/table/table.styles';
import { mapSelectCheckboxStyles } from '~/map/listing/tableData/mapRow/mapRow.styles';

type TableCheckboxCellProps = Pick<ComponentProps<typeof CheckboxComponent>, 'checkedSetter' | 'isChecked' | 'isDisabled'> & Readonly<{
  className?: string;
  checkboxStyle?: ComponentProps<typeof CheckboxComponent>['checkmarkStyle'];
}>;

export const TableCheckboxCellComponent = forwardRef<HTMLDivElement, TableCheckboxCellProps>(({
  checkboxStyle,
  className,
  isChecked,
  checkedSetter,
  isDisabled,
  ...restProps
}, ref) => {
  return (
    <div
      {...restProps}
      ref={ref}
      className={className}
      css={checkboxCellStyles}
    >
      <CheckboxComponent
        checkedSetter={checkedSetter}
        isChecked={isChecked}
        isDisabled={isDisabled}
        checkmarkStyle={[mapSelectCheckboxStyles(isChecked), checkboxStyle]}
      />
    </div>
  );
});

TableCheckboxCellComponent.displayName = 'TableCheckboxCellComponent';
